import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BaseInsightPayload } from '../InsightDataPayload';
import { parseRequestsReceivedPayload } from '../payloads/requestsReceivedPayload';
import {
  InsightChartFactory,
  InsightChartFactoryProps,
} from '../insightChartFactory';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';

export const buildRequestsReceivedInsightFactory = (
  payload: BaseInsightPayload
): InsightChartFactory => {
  const parsedPayload = parseRequestsReceivedPayload(payload);
  const { received_requests } = parsedPayload.data.attributes.aggregate;

  return (props: InsightChartFactoryProps) => {
    const chart = new ChartBuilder()
      .setChartType(ChartType.KPI)
      .setProps({
        chartData: {
          value: received_requests.current ?? 0,
          trend: received_requests.percentage_change ?? 0,
          trendIsPercent: true,
          description: props.name,
        },
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
    });
  };
};
